export type RouteBulletShape = 'circle' | 'diamond';

export interface RouteBulletPresentation {
  id: string;
  label: string;
  shape: RouteBulletShape;
  descriptor: string;
}

/** Derive the shared visual presentation for a subway route bullet. */
export function routeBulletPresentation(routeId: string): RouteBulletPresentation {
  const id = routeId.toUpperCase();
  const shape = id.endsWith('X') ? 'diamond' : 'circle';
  let label = shape === 'diamond' ? id.slice(0, -1) : id;
  if (id === 'SIR' || id === 'SI') label = 'SIR';
  else if (['GS', 'FS', 'SS', 'H', 'S'].includes(id)) label = 'S';
  const descriptor = shape === 'diamond' ? `${label} express` : label;
  return { id, label, shape, descriptor };
}
